import React from 'react';

/**
 * The official Instagram app badge: the recognizable corner gradient
 * (yellow → orange → magenta → purple) with a white camera outline — NOT a flat
 * single-colour square. Instagram's brand IS the gradient; a flat fill reads as
 * off-brand. Every other platform mark is legitimately flat, so only this one
 * carries its own gradient. `useId` scopes the gradient per instance so multiple
 * icons on one page never collide on the def id.
 */
export const InstagramIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const gradientId = `ig-gradient-${React.useId()}`;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props}>
      <defs>
        <radialGradient id={gradientId} cx="0.3" cy="1" r="1.1">
          <stop offset="0" stopColor="#FEDA75" />
          <stop offset="0.25" stopColor="#FA7E1E" />
          <stop offset="0.5" stopColor="#D62976" />
          <stop offset="0.75" stopColor="#962FBF" />
          <stop offset="1" stopColor="#4F5BD5" />
        </radialGradient>
      </defs>
      <rect x="24" y="24" width="208" height="208" rx="56" fill={`url(#${gradientId})`} />
      <rect
        x="72"
        y="72"
        width="112"
        height="112"
        rx="36"
        fill="none"
        stroke="#fff"
        strokeWidth="16"
      />
      <circle cx="128" cy="128" r="28" fill="none" stroke="#fff" strokeWidth="16" />
      <circle cx="174" cy="82" r="10" fill="#fff" />
    </svg>
  );
};
